<template>
  <div>
    <van-row>
      <van-search
        v-model="value"
        :show-action="false"
        placeholder="搜索学习课程"
        @search="onSearch"
        @cancel="onCancel"
        class="search"
      />
      <div class="searchRight" @click="openMoreSearch">
        <van-icon class="m-t-04" name="setting-o" />
        <p class="f-s-6">更多</p>
      </div>
    </van-row>
    <MoreSearch ref="moreSearch" @goSearch="goSearch" />
  </div>
</template>

<script>
import MoreSearch from '@/components/seleClass/moreSearch'
export default {
  components:{
    MoreSearch
  },
  data() {
    return {
      value: "",
    };
  },
  methods: {
    openMoreSearch(){
      this.$refs.moreSearch.show = true
    },
    goSearch(){
      this.value = ""
      this.$emit('goSearch')
    },
    onSearch() {
      this.$refs.moreSearch.rightActive = 0
      this.$emit("textSearch")
    },
    onCancel() {
      console.log("取消");
    },
  },
};
</script>

<style lang="less" scoped>
.search {
  width: 92%;
  float: left;
  .van-search__content {
    border-radius: 20px;
  }
}
.searchRight {
  width: 8%;
  float: left;
  background: white;
  height: 54px;
  p {
    line-height: 8px;
  }
}
</style>